import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaStethoscope, FaProcedures, FaHospital, FaUserMd, FaHeart, FaClinicMedical, FaCheckCircle, FaSearchPlus, FaTint, FaHeartBroken, FaDisease, FaBandAid, FaClipboardCheck, FaDna, FaVirus, FaCut, FaNotesMedical, FaHandHoldingMedical, FaFacebookF, FaLinkedinIn, FaTwitter, FaShieldAlt, FaArrowRight } from "react-icons/fa";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import WorkingProcess from "../Section/WorkingProcess";
import Spacing from "../Spacing";
import Post from "../Post";
import styled from "styled-components";
import FaqSectionStyle4 from "../FaqSection/FaqSectionStyle4";
import { Helmet } from "react-helmet";
import RecentPostWidget from "../Widget/RecentPostWidget";
import NewsletterStyle5 from "../Widget/NewsletterStyle5";

const workingProcessData = [
  {
    title: "Preoperative Evaluation",
    subTitle:
      "To plan the surgical approach, a comprehensive assessment of the patient’s medical history, symptoms, and diagnostic imaging, such as ultrasound and MRI, is conducted. This is followed by a discussion of surgical goals, potential risks, benefits, and expected outcomes.",
    iconUrl: "/images/home_2/department_icon33.png",
    number: "01",
  },
  {
    title: "Surgical Procedure",
    subTitle:
      "General anesthesia is administered to ensure comfort and safety during the procedure. Small keyhole incisions are made near the navel and lower abdomen to insert a laparoscope, which is a camera, and surgical instruments. The surgery involves precise visualization of pelvic organs and the surgical removal or treatment of targeted tissues such as fibroids, cysts, or endometriotic lesions. Finally, the incisions are closed with sutures or surgical tape, and a sterile dressing is applied.",
    iconUrl: "/images/home_2/department_ichi22.png",
    number: "02",
  },
  {
    title: "Postoperative Care",
    subTitle:
      "After the procedure, patients typically recover in a designated recovery area under medical supervision until they are fully awake and stable. Medications are provided to manage postoperative discomfort, and patients receive instructions for home care and follow-up appointments.",
    iconUrl: "/images/home_2/department_ichi33.png",
    number: "03",
  },
];

const relatedBlog = [
  {
    title:
      "The Importance of Mental Health: Understanding and Managing Anxiety Disorders",
    thumbUrl: "/images/blog/post_1.jpeg",
    date: "March 12",
    btnText: "Learn More",
    href: "/blog/blog-details",
  },
];

const faqData = [
  {
    title:
      " What conditions can be treated with laparoscopic surgery at Pluro Jabalpur Fertility Centre ?",
    content:
      "Laparoscopic surgery at Pluro Jabalpur Fertility Centre is used to treat various gynecological conditions that can affect fertility. These conditions include fibroids, which are non-cancerous growths in the uterus that can cause pain, heavy periods, and infertility; ovarian cysts, which are fluid-filled sacs that develop on the ovaries and can interfere with ovulation and fertility; endometriosis, a condition where tissue similar to the lining of the uterus grows outside the uterus, often causing pain and infertility; and pelvic adhesions, which are scar tissue that forms between pelvic organs and can disrupt reproductive function.",
  },
  {
    title:
      "What are the benefits of laparoscopic surgery for these conditions ?",
    content:
      "Laparoscopic surgery offers several advantages over traditional open surgery. It is minimally invasive, with small incisions usually less than an inch, resulting in less pain, scarring, and faster recovery compared to open surgery. Most procedures are performed on an outpatient basis or require a short hospital stay, leading to a shorter hospital stay overall. Additionally, patients can return to normal activities sooner, typically within a few days to weeks depending on the procedure, ensuring a quicker recovery.",
  },
  {
    title: "How is laparoscopic surgery performed for these conditions ?",
    content:
      "Laparoscopic surgery involves several steps. First, general anesthesia is administered to ensure the patient is comfortable and pain-free during the procedure. Then, several small incisions are made near the belly button and lower abdomen. A laparoscope, which is a thin, lighted tube with a camera, and surgical instruments are inserted through these incisions. The surgeon uses the laparoscope to view the pelvic organs and perform the necessary surgical procedures, such as removing fibroids, cysts, or endometriosis tissue. Finally, the incisions are closed with sutures or surgical tape.",
  },
  {
    title:
      "What are the risks and complications associated with laparoscopic surgery ?",
    content:
      "While laparoscopic surgery is generally safe, it carries some risks, like any surgical procedure. These include the risk of infection at the incision sites or within the pelvic cavity, minimal risk of bleeding during or after the procedure, rare risk of accidental damage to surrounding organs such as the bladder or intestines, adverse reactions to anesthesia (though rare), and mild to moderate discomfort or pain after the procedure, which is usually managed with pain medication.",
  },
  {
    title:
      "How should I prepare for laparoscopic surgery at Pluro Jabalpur Fertility Centre ?",
    content:
      "Preparation for laparoscopic surgery includes undergoing any required medical tests or evaluations as recommended by your doctor. You should follow preoperative instructions regarding fasting, medication adjustments, and personal hygiene. Additionally, it is important to arrange for transportation to and from the hospital or clinic, as well as assistance during recovery if needed. Be sure to inform your doctor of any allergies, medical conditions, or medications you are currently taking.",
  },
];

const recentPostData = [
  {
    title: `Advanced IUI Treatments at Pluro Jabalpur Fertility Centre`,
    author: "Dr. Archana Shrivastava",
    date: "August 10, 2023",
    href: "/IUI",
  },
  {
    title: `Advanced IVF Treatments`,
    author: "Dr. Archana Shrivastava",
    date: "August 10, 2023",
    href: "/IVF",
  },
  {
    title: `Advanced ICSI Treatments at Pluro Jabalpur Fertility Centre`,
    author: "Dr. Archana Shrivastava",
    date: "August 10, 2023",
    href: "/ICSI",
  },
  {
    title: `Advanced Male Infertility Treatments at Pluro Jabalpur Fertility Centre`,
    author: "Dr. Archana Shrivastava",
    date: "August 10, 2023",
    href: "/Tesa-Pesa",
  },
  {
    title: `Advanced Diagnostic and Surgical Techniques at Pluro Jabalpur Fertility Centre`,
    author: "Dr. Archana Shrivastava",
    date: "August 10, 2023",
    href: "/Laparoscopy",
  },
];

const colorOrange = "#FF8B13";
const colorPurple = "#9E58B6";

export default function LaparoscopyRemoval() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('cs_active');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.cs_reveal').forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Helmet>
        <title>Laparoscopic Surgery – Fibroids, Cysts, Endometriosis Treatment</title>
        <meta name="description" content="Effective laparoscopic treatment of fibroids, ovarian cysts, and endometriosis to enhance fertility and reduce discomfort." />
        <meta name="keywords" content="laparoscopic surgery, fibroid removal, ovarian cyst treatment, endometriosis surgery" />
        <link rel="canonical" href="https://jabalpurivfcentre.com/Laparoscopy-Removal" />
      </Helmet>
      <Container className="cs_iui_new_wrap">
        {/* Banner Section */ }
        <BannerSectionStyle3
          bgUrl="/images/Laparoscopy-Removal.jpg"
          title="Welcome to <br /> Pluro Jabalpur<br /> Fertility Center"
          subTitle="Advanced Laparoscopic Surgeries"
        />

        {/* Post Meta & Share Section */ }
        <div className="container" style={ { marginTop: '60px' } }>
          <div className="cs_blog_details_info cs_reveal">
            <div className="cs_blog_details_info_left">
              <div className="cs_blog_details_date">
                March 12, 2024 | Dr. Archana Srivastava
              </div>
            </div>
            <div className="cs_social_links_wrap">
              <h2>Share:</h2>
              <div className="cs_mcp_doctor_socials mb-0 align-items-center">
                <Link to="https://www.facebook.com/PluroJabalpurFertilityAndIVFCentre/" className="cs_mcp_social_btn">
                  <FaFacebookF />
                </Link>
                <Link to="https://www.linkedin.com/in/jabalpur-fertility-centre-97504a227/" className="cs_mcp_social_btn">
                  <FaLinkedinIn />
                </Link>
                <Link to="https://x.com/jabalpurivf1" className="cs_mcp_social_btn">
                  <FaTwitter />
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Intro Section */ }
        <Section topMd={ 60 } topLg={ 40 } topXl={ 30 }>
          <div className="container">
            <div className="row align-items-center cs_reveal cs_premium_intro_row">
              <div className="col-lg-5">
                <div className="cs_intro_left">
                  <h1 className="cs_intro_title" style={ { fontSize: '32px' } }>
                    Advanced Minimally Invasive Surgical Solutions at Pluro Jabalpur Fertility Centre
                  </h1>
                  <div className="cs_intro_divider" style={ { backgroundColor: colorOrange } }></div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="cs_intro_right">
                  <p className="mb-0">
                    Laparoscopic surgery, also known as minimally invasive surgery or keyhole surgery, is a highly effective approach for the removal of fibroids, ovarian cysts, endometriosis, and other gynecological conditions. At Pluro Jabalpur Fertility Centre, recognized as the Best Fertility Clinic in Jabalpur, we specialize in laparoscopic procedures under the expert guidance of Dr. Archana Shrivastava, the Best IVF Doctor in Jabalpur. Our mission is to provide personalized, compassionate care and deliver optimal surgical outcomes for women’s health issues.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* What Conditions Can be Treated - Light grey background for white card pop */ }
        <section className="cs_section_light_bg">
          <div className="container">
            <div className="text-center mb-5 cs_reveal">
              <h2 className="cs_fs_40 cs_medium" style={ { fontFamily: '"Playfair Display", serif', color: '#1c2b38', marginBottom: '15px' } }>What Conditions Can be Treated with Laparoscopic Surgery ?</h2>
              <div style={ { width: '60px', height: '3px', backgroundColor: colorPurple, margin: '0 auto 25px' } }></div>
            </div>

            <div className="row cs_gap_y_40">
              {/* Fibroids */ }
              <div className="col-lg-4 col-md-6">
                <div className="cs_premium_card_v2 theme-purple cs_reveal">
                  <div className="icon_container_v2">
                    <FaDisease />
                  </div>
                  <h3>Uterine Fibroids</h3>
                  <p>Non-cancerous growths that develop in the uterus and may cause heavy menstrual bleeding, pelvic pain, or fertility issues.</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="cs_premium_card_v2 theme-purple cs_reveal">
                  <div className="icon_container_v2">
                    <FaHandHoldingMedical />
                  </div>
                  <h3>Myomectomy</h3>
                  <p>Surgical removal of fibroids while preserving the uterus, which may be recommended for women who wish to retain their fertility.</p>
                </div>
              </div>

              {/* Endometriosis */ }
              <div className="col-lg-4 col-md-6">
                <div className="cs_premium_card_v2 theme-purple cs_reveal">
                  <div className="icon_container_v2">
                    <FaDna />
                  </div>
                  <h3>Endometriosis</h3>
                  <p>A condition where tissue similar to the lining of the uterus grows outside the uterus, often causing pain, infertility, or other complications.</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="cs_premium_card_v2 theme-purple cs_reveal">
                  <div className="icon_container_v2">
                    <FaCut />
                  </div>
                  <h3>Excision Surgery</h3>
                  <p>Precise removal of endometriotic lesions and adhesions to relieve symptoms and improve fertility outcomes.</p>
                </div>
              </div>

              {/* Other Conditions */ }
              <div className="col-lg-4 col-md-6">
                <div className="cs_premium_card_v2 theme-purple cs_reveal">
                  <div className="icon_container_v2">
                    <FaSearchPlus />
                  </div>
                  <h3>Tubal Reversal Surgery</h3>
                  <p>Reversal of tubal ligation or surgical repair of fallopian tubes to restore fertility.</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="cs_premium_card_v2 theme-purple cs_reveal">
                  <div className="icon_container_v2">
                    <FaBandAid />
                  </div>
                  <h3>Pelvic Adhesions</h3>
                  <p>Surgical release of scar tissue (adhesions) that may form after previous surgeries or infections, potentially causing pain or infertility.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Working Process */ }
        <Section topMd={ 80 } topLg={ 60 } topXl={ 40 }>
          <WorkingProcess
            sectionTitle="The Laparoscopic Surgery Procedure"
            sectionTitleUp=""
            sectionTitleDown=""
            sectionSubTitle=""
            data={ workingProcessData }
          />
        </Section>

        {/* Popular Articles and Newsletter Section */ }
        <Section topMd={ 100 } topLg={ 80 } topXl={ 60 }>
          <div className="container cs_reveal">
            <div className="row cs_gap_y_40 justify-content-center">
              <div className="col-lg-7">
                <div className="cs_sidebar_item" style={ { height: '100%' } }>
                  <RecentPostWidget title="Popular Articles" data={ recentPostData } />
                </div>
              </div>
              <div className="col-lg-5">
                <div className="cs_sidebar_item widget_categories" style={ { height: '100%' } }>
                  <NewsletterStyle5 title="Newsletter Sign Up Form" />
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* Benefits Section - Warm cream background */ }
        <section className="cs_section_warm_bg">
          <div className="container cs_reveal">
            <div className="text-center mb-5">
              <h2 className="cs_fs_40 cs_medium" style={ { fontFamily: '"Playfair Display", serif', color: '#1c2b38', marginBottom: '15px' } }>Benefits of Laparoscopic Surgery</h2>
              <div style={ { width: '60px', height: '3px', backgroundColor: colorOrange, margin: '0 auto 25px' } }></div>
            </div>

            <div className="row cs_gap_y_40">
              <div className="col-lg-3 col-md-6">
                <div className="cs_earth_card cs_reveal">
                  <div className="icon_container_v2">
                    <FaProcedures />
                  </div>
                  <h3>Minimally Invasive</h3>
                  <p>Small incisions result in less pain, reduced scarring, and faster recovery compared to traditional open surgery.</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="cs_earth_card cs_reveal">
                  <div className="icon_container_v2">
                    <FaHospital />
                  </div>
                  <h3>Shorter Hospital Stay</h3>
                  <p>Most procedures are performed on an outpatient basis or require only a short hospital stay.</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="cs_earth_card cs_reveal">
                  <div className="icon_container_v2">
                    <FaHeart />
                  </div>
                  <h3>Preservation of Fertility</h3>
                  <p>Surgical techniques are tailored to preserve reproductive organs and function whenever possible.</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="cs_earth_card cs_reveal">
                  <div className="icon_container_v2">
                    <FaStethoscope />
                  </div>
                  <h3>Effective Treatment</h3>
                  <p>Laparoscopic surgery offers precise diagnosis and treatment of gynecological conditions with high success rates.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Us Section */ }
        <div className="cs_premium_why_choose_split" style={ { marginTop: '80px', paddingTop: '60px', borderTop: '1px solid rgba(0,0,0,0.06)' } }>
          <div className="row align-items-center justify-content-center">
            {/* Left Column: Image (roughly 50% / col-lg-5) */ }
            <div className="col-lg-5 col-md-12 mb-5 mb-lg-0 d-flex justify-content-center">
              <div className="cs_pwc_right cs_reveal">
                <div className="cs_pwc_image_container">
                  <img src="/images/about/Dr.Archana.png" alt="Dr. Archana Shrivastava" className="cs_pwc_arch_img" />
                  <div className="cs_pwc_stat_card">
                    <div className="cs_pwcs_num">24+</div>
                    <div className="cs_pwcs_label">years of<br />experience</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: Text Content (roughly 50% / col-lg-5) */ }
            <div className="col-lg-5 col-md-12 pl-lg-5">
              <div className="cs_pwc_left cs_reveal">
                <span className="cs_pwc_badge">Why choose us</span>
                <h2 className="cs_pwc_heading" style={ { fontSize: '32px', lineHeight: '1.3', marginBottom: '28px' } }>Why Choose Pluro Jabalpur Fertility Centre?</h2>

                <p style={ { fontSize: '16px', color: '#586776', lineHeight: '1.7', marginBottom: '30px' } }>
                  We provide exceptional surgical standards backed by internationally certified training and advanced medical technologies to ensure patient safety and comfort.
                </p>

                <div className="cs_pwc_features">
                  <div className="cs_pwc_row cs_reveal">
                    <div className="cs_pwcr_icon theme_orange">
                      <FaUserMd />
                    </div>
                    <div className="cs_pwcr_text">
                      <h4>Expertise and Experience</h4>
                      <p>Dr. Archana Shrivastava is an expert advanced laparoscopic Surgeon, who has attained a diploma from the world's best center in KIEL Germany.</p>
                    </div>
                  </div>

                  <div className="cs_pwc_row cs_reveal">
                    <div className="cs_pwcr_icon theme_purple">
                      <FaClinicMedical />
                    </div>
                    <div className="cs_pwcr_text">
                      <h4>Advanced Technology</h4>
                      <p>State-of-the-art laparoscopic equipment and facilities ensure optimal surgical outcomes and patient safety.</p>
                    </div>
                  </div>

                  <div className="cs_pwc_row cs_reveal">
                    <div className="cs_pwcr_icon theme_orange">
                      <FaStethoscope />
                    </div>
                    <div className="cs_pwcr_text">
                      <h4>Comprehensive Care</h4>
                      <p>From initial consultation and diagnostic evaluation to surgical treatment and postoperative follow-up, we provide comprehensive care throughout your surgical journey.</p>
                    </div>
                  </div>

                  <div className="cs_pwc_row cs_reveal">
                    <div className="cs_pwcr_icon theme_purple">
                      <FaHeart />
                    </div>
                    <div className="cs_pwcr_text">
                      <h4>Patient-Centered Approach</h4>
                      <p>We prioritize your comfort, well-being, and informed decision-making, offering compassionate support at every step.</p>
                    </div>
                  </div>
                </div>

                <Link to="/contact" className="cs_pwc_btn" style={ { marginTop: '10px' } }>
                  Book a consultation <FaArrowRight />
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Section */ }
        <Section topMd={ 40 } topLg={ 20 } topXl={ 0 }>
          <div className="cs_iui_faq_wrapper cs_reveal">
            <FaqSectionStyle4
            sectionTitle="Frequently Asked <br />Questions"
            data={ faqData }
            faqImgUrl="/images/home_4/faq_img.jpg"
            spiningImgUrl="/images/home_1/about_mini.svg"
          />
          </div>
        </Section>

        {/* Contact Us Section */ }
        <Section topMd={ 60 } topLg={ 40 } topXl={ 20 } bottomMd={ 100 } bottomLg={ 80 } bottomXl={ 60 }>
          <div className="container cs_reveal">
            <div className="cs_ivf_contact_banner" style={ { background: '#c77842', borderRadius: '20px', padding: '60px 50px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '30px' } }>
              <div className="cs_icc_content" style={ { flex: '1', minWidth: '300px' } }>
                <h2 style={ { color: '#fff', fontSize: '36px', marginBottom: '15px', fontWeight: '700' } }>Contact Us</h2>
                <p style={ { color: 'rgba(255,255,255,0.9)', fontSize: '18px', margin: '0', lineHeight: '1.6' } }>
                  If you are considering laparoscopic surgery for the removal of fibroids, ovarian cysts, endometriosis, or other gynecological conditions, contact Pluro Jabalpur Fertility Centre today. Our dedicated team is here to provide expert care and support to address your health needs effectively.
                </p>
              </div>
              <div className="cs_icc_action">
                <Link to="/contact" className="cs_btn" style={ { background: '#fff', color: '#c77842', padding: '15px 40px', borderRadius: '50px', fontWeight: '600', fontSize: '18px', display: 'inline-flex', alignItems: 'center', textDecoration: 'none', boxShadow: '0 10px 20px rgba(0,0,0,0.1)' } }>
                  <span>Get in Touch</span>
                </Link>
              </div>
            </div>
          </div>
        </Section>

        {/* Related Articles */ }
        <Section bottomMd={ 200 } bottomLg={ 150 } bottomXl={ 110 }>
          <div className="container cs_reveal">
            <h2 className="mb-0 cs_fs_40 cs_medium">Related Articles</h2>
            <Spacing md="57" />
            <div className="row cs_gap_y_40">
              { relatedBlog?.map((item, index) => (
                <div className="col-xl-12" key={ index }>
                  <Post { ...item } />
                </div>
              )) }
            </div>
          </div>
        </Section>
      </Container>
    </>
  );
}

const Container = styled.div`
  .heading{
    font-size: 32px;
     @media (max-width: 991px) {
      font-size: 28px;
    }
  }
`;
